export default __webpack_public_path__ + "static/media/onboardingMobile.108611f4.png";